import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


// 项目样式初始化
import '@/assets/css/index.scss'

// 项目样式主题化
import '@/styles/theme.scss'

// PC端 rem 适配
// import "amfe-flexible/index"

// 引入 Element-Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'



createApp(App).use(store).use(router).use(ElementPlus).mount('#app')
